module.exports = __webpack_public_path__ + "static/img/4105_phase_function_Paper_PointsHejduk_Prediction.82f7cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4105_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +L2b
// module chunks = 0